import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { Box, Card, CardContent, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import 'swiper/css';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IGetCustomerWalletsInfoResponse } from '../../models/wallet.model';
import { getpervStateTab } from '../../redux/loansTab/loansTabSlice';
import './carousel.css';
import { ICarousel } from './ICarousel';
import CircularProgress from '@mui/material/CircularProgress';
import { useQueryClient } from 'react-query';
import { WALLET_KEY } from '../../config/cacheKey';




interface ICardDataFlow {
    cardData: IGetCustomerWalletsInfoResponse;
    cardFlow: Function;
    reloadBalance: Function;
    walletInfoLoading: boolean

}

const CustomCarouselCard: React.FC<ICardDataFlow> = ({
    cardData,
    cardFlow,
    reloadBalance,
    walletInfoLoading
}) => (

    <Card
        sx={{
            background: `${cardData.colorHexCode}`,
            borderRadius: 4,
            height: '180px',
            position: "relative",
            width: "100%"
        }}
        className="!rounded-[5px] carousel-cards"
        onClick={() => cardFlow()}
    >
        <CardContent
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '160px',
                zIndex: "2",
                position: "relative"
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '10px',
                }}
            >
                {cardData.expirationDatePersian ? <Typography color="white" sx={{ fontSize: '.8rem' }}>
                    {cardData.expirationDatePersian}
                    <br />
                    تاریخ انقضا
                </Typography> :
                    <Typography color="white" sx={{ fontSize: '.8rem' }}>
                    </Typography>
                }
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {walletInfoLoading ? <CircularProgress sx={{ color: "#BBA57A" }} size={20} /> : <Typography
                        color="white"
                        sx={{ fontSize: '1.1rem', fontWeight: 'bold', letterSpacing: "1px" }}
                    >
                        {cardData.balance.toLocaleString('fa')} <span className="text-sm">ریال</span>
                    </Typography>}

                </Box>
            </Box>
            <Box sx={{ marginBottom: '10px', display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                <Typography color="white" sx={{ fontSize: '.9rem' }}>
                    {cardData.title}
                </Typography>
                {walletInfoLoading ? <CircularProgress sx={{ color: "#BBA57A" }} size={20} /> : <Typography
                    color="white"
                    sx={{ textAlign: 'end', fontSize: '.8rem' }}
                    onClick={() => reloadBalance()}

                >
                    <ReplayOutlinedIcon sx={{ fontSize: '25px' }} />
                </Typography>}
            </Box>
        </CardContent>
    </Card>
);
const CardCarousel = ({
    setTempWalletKey, customerWallets, reloadBalance, walletInfoLoading
}: ICarousel) => {
    const [swiperInstance, setSwiperInstance] = useState<any>(null);
    const selectedWalletIndex = useQueryClient()
    const dispatch = useDispatch();
    const handleCardClick = () => {
        dispatch(getpervStateTab({ prevState: 'walletFlow' }))
    }

    useEffect(() => {
        if (swiperInstance && selectedWalletIndex?.getQueryData("WALLET_KEY_INDEX") !== undefined) {
            swiperInstance.slideTo(selectedWalletIndex?.getQueryData("WALLET_KEY_INDEX"), 0);

        }
    }, [swiperInstance, selectedWalletIndex?.getQueryData("WALLET_KEY_INDEX")]);




    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
            }}
        >
            <Swiper
                onSwiper={setSwiperInstance}
                slidesPerView={customerWallets?.length > 1 ? 1.3 : 1.1}
                spaceBetween={customerWallets?.length > 1 ? 100 : 0}
                pagination={true}
                scrollbar={false}
                navigation={false}
                initialSlide={parseInt(selectedWalletIndex?.getQueryData("WALLET_KEY_INDEX") as string) || 0}
                style={{
                    width: '100%',
                }}
                loop={false}
                centeredSlides={true}
                effect="coverflow"
                speed={300}
                coverflowEffect={{
                    rotate: 0,
                    stretch: customerWallets?.length > 1 ? 50 : 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: false
                }}

                modules={[EffectCoverflow, Pagination]}
                onRealIndexChange={(e: any) => {
                    selectedWalletIndex.setQueryData("WALLET_KEY_INDEX", e.realIndex);
                    const key = customerWallets?.filter(
                        (_, index) => index === e.realIndex)[0]?.key;
                    if (key) {
                        selectedWalletIndex.setQueryData(WALLET_KEY, key);
                    }
                }}
                className="cards-carousel"
            >
                {customerWallets?.map((card, index) => (
                    <Box key={index} sx={{ padding: 2 }} >
                        <SwiperSlide>
                            <CustomCarouselCard walletInfoLoading={walletInfoLoading} cardData={card} cardFlow={handleCardClick} reloadBalance={() => reloadBalance(card.key)} />
                        </SwiperSlide>
                    </Box>
                ))}
            </Swiper>
        </Box>
    );
};

export default CardCarousel;
